<template>
  <div class="q-pa-sm">
    <!-- <div>全局视图</div>
    <el-divider class="in"></el-divider> -->
    <div class="view">
      <div class="view_1">
        <div>
          <div>
            项目
          </div>
          <div class="view_4">{{divData.projects}}</div>
        </div>
      </div>
      <div class="view_1" @click="jum(4)">
        <div>
          <div style="color:red">待处理任务</div>
          <div class="view_4">{{divData.daichuli}}</div>
        </div>
      </div>
      <div class="view_1" @click="jum(1)">
        <div>
          <div style="color:red">未开始</div>
          <div class="view_4">{{divData.weikaishi}}</div>
        </div>
      </div>
      <div class="view_1" @click="jum(2)">
        <div>
          <div>进行中</div>
          <div class="view_4">{{divData.jingxingzhong}}</div>
        </div>
      </div>
      <div class="view_1" @click="jum(3)">
        <div>
          <div>已完成</div>
          <div class="view_4">{{divData.yiwancheng}}</div>
        </div>
      </div>
      <div class="view_1">
        <div class="view_3">
          <el-progress type="dashboard" :percentage="divData.wangchenglu" :color="colors"></el-progress>
          <div>完成率</div>
        </div>
      </div>
    </div>
    <el-table :data="tableData" border
              :header-cell-style="{background:'#f5f5f5',color:'rgb(82,82,82)',fontSize:'16px',fontWeight:400}"
              style="margin-top:20px">
      <el-table-column label="项目" prop="project_name" align="center">
      </el-table-column>
      <el-table-column v-if="dept_id == 0" label="归档团队" prop="dept_name" align="center">

      </el-table-column>
      <el-table-column label="待处理任务" prop="daichuli" align="center">

      </el-table-column>
      <el-table-column label="未开始" prop="weikaishi" align="center">

      </el-table-column>
      <el-table-column label="进行中" prop="jingxingzhong" align="center">

      </el-table-column>
      <el-table-column label="已完成" prop="yiwancheng" align="center">

      </el-table-column>
      <el-table-column label="完成率" prop="wangchenglu" align="center">
        <template slot-scope="scope">
          <el-progress
            :percentage="scope.row.wangchenglu"
            :status="scope.row.status"
            :color="colors">
          </el-progress>
        </template>
      </el-table-column>
      <el-table-column label="延期未完成" prop="yanqiwei" align="center">

      </el-table-column>
      <el-table-column label="延期完成" prop="yanqiwang" align="center">

      </el-table-column>
      <el-table-column label="延期完成率" prop="yanqilu" align="center">
        <template slot-scope="scope">
          <el-progress
            :percentage="filterData(scope.row.yanqilu)"
            :status="scope.row.status"
            :color="colors">
          </el-progress>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
  import {getviews} from "../../api/view";

  export default {
    data() {
      return {
        //选取的部门id
        dept_id: localStorage.getItem('dept_id'),
        percentage: 10,
        tableData: [],
        divData: [],
        jindutiao: [],
        colors: [
          {color: '#f56c6c', percentage: 20},
          {color: '#e6a23c', percentage: 40},
          {color: '#5cb87a', percentage: 60},
          {color: '#1989fa', percentage: 80},
          {color: '#6f7ad3', percentage: 100}
        ]
      }
    },
    // 注册组件
    components: {},
    /**
     * 里面的方法只有被调用才会执行
     */
    methods: {
      jum(status){
        this.$router.push(
          {
              path: '/work/itemview',
              query: {
                  status: status
              }
          }
        )
      },
      filterData(val){
        //百分比必须为0-100，否则报错[Vue warn]:Invalid prop:custom validator check failed for prop "percentage"
        let result = 0
        if(val >=0&&(val<=100)){
          result = parseFloat((val).toPrecision(12))
        }
        return result
      },
      getData() {
        let params = {
          token: localStorage.getItem("token"),
        }
        getviews(params).then(res => {
          if (res.errno === 0) {
            this.divData = res.data.stats
            for (var i in res.data.projects) {
              this.tableData.push(res.data.projects[i])
            }
            for (let i in this.tableData) {
              this.jindutiao.push(this.tableData[i].wangchenglu)
            }
          } else if (res.errno === 401) {
            this.$store.dispatch("LogOut").then(() => {
              location.reload(); // 为了重新实例化vue-router对象 避免bug
            });
          } else {
            this.$message.error(res.error);
          }
        })
      }
    },
    mounted() {
      this.dept_id = localStorage.getItem('dept_id')
      this.getData()
    }
  }
</script>

<style scoped>

  .q-pa-sm {
    background-color: #fbfbfb;
  }

  .view {
    display: flex;
    padding: 20px;
    text-align: center;
    background-color: #ffffff;
    /*box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04)*/
  }

  .view div:nth-child(6) {
    border-right: none;
  }

  .view_1 {
    display: flex;
    padding: 5px 0;
    text-align: center;
    align-items: center;
    border-right: 1px solid #eff2f6;
    width: 50%;
    box-sizing: border-box;
    justify-content: space-around;
    color: #141464;
    font-size: 16px;
    font-weight: bold;
    cursor: pointer;
  }

  .view_3 >>> .el-progress-circle {
    height: 77px !important;
    width: 80px !important;
  }

  .view_4 {
    margin-top: 10px;
    font-size: 30px;
  }
</style>



// WEBPACK FOOTER //
// src/views/work/gloview.vue